import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { of, Subject } from "rxjs";
import { delay, switchMap, takeUntil, tap } from "rxjs/operators";

@Component({
	selector: "app-multiline-list",
	templateUrl: "./multiline-list.component.html",
	styleUrls: ["./multiline-list.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultilineListComponent implements OnInit, AfterViewInit {
	@Input() public data: [any, string][] = [];
	@Output() public appInput: EventEmitter<string> = new EventEmitter<string>();
	@Output() public appSelect: EventEmitter<[any, string]> = new EventEmitter<[any, string]>();
	@Output() public appScrolled: EventEmitter<void> = new EventEmitter<void>();
	@ViewChild("input", { static: true }) public input?: ElementRef<HTMLInputElement>;
	public list: [any, string][] = [];
	public scroll$: Subject<HTMLElement> = new EventEmitter<HTMLElement>();
	public input$: Subject<string> = new EventEmitter<string>();
	public loading = true;
	public unsubscribe$$: Subject<void> = new Subject<void>();

	constructor(
		private cdr: ChangeDetectorRef,
	) { }

	public ngOnInit(): void {
		this.loading = true;
		this.cdr.detectChanges();
		this.scroll$.pipe(
			switchMap(el => of(el).pipe(delay(100))),
			takeUntil(this.unsubscribe$$)
		).subscribe(() => {
			this.appScrolled.emit();
		});
		this.input$.pipe(
			tap(() => this.loading = true),
			switchMap(el => of(el).pipe(delay(300))),
			takeUntil(this.unsubscribe$$)
		).subscribe((value) => {
			value = value.toLocaleLowerCase();
			if (value !== "") {
				this.list = this.data.filter(item => item[1].toLocaleLowerCase().includes(value));
			} else {
				this.list = this.data.slice(0);
			}
			this.appInput.emit(value);
		});
	}

	public ngOnChanges(simpleChanges: SimpleChanges): void {
		if (simpleChanges.data) {
			this.list = this.data;
			this.loading = false;
		}
	}

	public ngAfterViewInit(): void {
		this.input?.nativeElement.focus();
	}

	public onInput(value: string): void {
		this.input$.next(value);
	}

	public select(item: [any, string]): void {
		this.appSelect.emit(item);
	}

	public onScroll(scrollHeight: number, scrollTop: number, height: number): void {
		if (scrollTop !== 0 && (scrollHeight - (height + scrollTop)) <= 60) {
			this.scroll$.next();
		}
	}
}
